import { Link } from 'react-router-dom'
import { Card } from '@/common/ui/Card/Card'
import type { ProductScoreContainerSchema, ProductScoreSchema } from '@/common/api/client/types.gen'
import { CompanyStatsProductScorePill } from './CompanyStatsProductScorePill'

type CompanyStatsProductsRankingProps = {
    data: ProductScoreContainerSchema
}

type ProductRankingCardProps = {
    title: string
    products: ProductScoreSchema[]
}

const ProductRankingRow = ({ rank, product }: { rank: number; product: ProductScoreSchema }) => (
    <li className='grid grid-cols-[1.5rem_minmax(0,1fr)_auto] items-start gap-3 border-b border-white/10 py-3 last:border-b-0 last:pb-0 first:pt-0'>
        <span className='text-sm tabular-nums text-base-content/40' aria-hidden>
            {rank}
        </span>
        <Link
            to={`/app/products/${product.id}/analytics`}
            className='text-sm leading-snug text-base-content/80 link link-hover min-w-0'
            aria-label={`${product.name}, перейти к аналитике`}
        >
            {product.name}
        </Link>
        <CompanyStatsProductScorePill score={product.score} maxScore={product.max_score} />
    </li>
)

const ProductRankingCard = ({ title, products }: ProductRankingCardProps) => (
    <Card color='primary' className='h-full'>
        <h3 className='mb-4 text-xs font-bold uppercase tracking-wide text-white'>{title}</h3>
        {products.length === 0 ? (
            <p className='text-sm text-base-content/50'>Нет данных</p>
        ) : (
            <ol className='flex flex-col' aria-label={title}>
                {products.map((product, index) => (
                    <ProductRankingRow key={product.id} rank={index + 1} product={product} />
                ))}
            </ol>
        )}
    </Card>
)

export const CompanyStatsProductsRanking = ({ data }: CompanyStatsProductsRankingProps) => {
    const topProducts = data.top ?? []
    const bottomProducts = data.bottom ?? []

    if (topProducts.length === 0 && bottomProducts.length === 0) return null

    return (
        <div className='flex flex-col gap-4'>
            <ProductRankingCard title='🏆 Топ-5 товаров' products={topProducts} />
            <ProductRankingCard title='⚠️ Требуют доработки' products={bottomProducts} />
        </div>
    )
}
